import { Loader2 } from "lucide-react";

const LoadingStatus = ({ className = "" }) => (
  <div
    className={`loading-status${className ? ` ${className}` : ""}`}
    role="status"
    aria-label="טוען"
  >
    <Loader2
      className="loading-status__icon"
      size={32}
      strokeWidth={2}
      aria-hidden
    />
  </div>
);

export default LoadingStatus;
